export default "__VITE_ASSET__DpEPdzMq__"